import {
  ALL_BLOGS_REQUEST,
  ALL_BLOGS_SUCCESS,
  CLEAR_ERRORS,
  ALL_BLOGS_FAIL,
  LOAD_BLOG_REQUEST,
  LOAD_BLOG_SUCCESS,
} from "app/utils/constants/blogConstants";

import axios from "axios";

export const loadClient = () => async (dispatch) => {
  try {
    const config = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };
    dispatch({ type: LOAD_BLOG_REQUEST });
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/profile/list-us-profile`,
      config
    );

    dispatch({ type: LOAD_BLOG_SUCCESS, payload: data.data.result });
  } catch (error) {
    dispatch({
      type: ALL_BLOGS_FAIL,
      payload: error.response.data.description,
    });
  }
};

export const getAllBlogs =
  (search_value, sort, sortBy, page) => async (dispatch) => {
    try {
      dispatch({ type: ALL_BLOGS_REQUEST });
      const body = {
        filters: {},
        searchFields: {
          string: ["title", "language"],
          numbers: ["created_by"],
        },
      };
      if (!search_value) {
        search_value = "";
      }
      const urlParams = new URLSearchParams({
        search: search_value.trim(),
        page: page,
        sort: sort,
        sortBy: sortBy,
      });
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.post(
        `${process.env.REACT_APP_URL}/blog/list-blog?${urlParams.toString()}`,
        body,
        config
      );

      console.log(data, "data");
      dispatch({
        type: ALL_BLOGS_SUCCESS,
        payload: {
          data: data?.data?.result,
          totalPage: data?.data?.totalPages,
        },
      });
    } catch (error) {
      dispatch({
        type: ALL_BLOGS_FAIL,
        payload: error.response.data.message,
      });
    }
  };

export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
